import { takeLatest, put, call } from 'redux-saga/effects';

import {
  getEstoqueAtual,
  getEstoqueAtualPdf,
  getEstoqueAtualExcel,
} from '../service';
import {
  LIST_RELATORIO_ESTOQUE_ATUAL,
  LIST_RELATORIO_ESTOQUE_ATUAL_PENDING,
  LIST_RELATORIO_ESTOQUE_ATUAL_SUCCESS,
  LIST_RELATORIO_ESTOQUE_ATUAL_FAILURE,
  LIST_RELATORIO_ESTOQUE_ATUAL_PDF_SUCCESS
} from '../actionTypes';
import { storage } from '@commons';
import { CONFIG_SESSION } from '@handler/common/startSession';

function* sagaListAllRelatorioEstoqueAtual(action) {
  yield put({ type: LIST_RELATORIO_ESTOQUE_ATUAL_PENDING });

  try {
    const idPropriedade = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;
    const totalizar = action.totalizarPorLocalEstoque === 'S' ? true : false;

    if (!action.pdf && !action.excel) {
      const estoqueAtual = yield call(getEstoqueAtual, idPropriedade, action.args, totalizar);
      yield put({ type: LIST_RELATORIO_ESTOQUE_ATUAL_SUCCESS, estoqueAtual });
    } else {
      let where = '';
      if (action.args?.produto?.id) {
        where += `&produto=${action.args.produto.id}`;
      }
      if (action.args?.localEstoque?.id) {
        where += `&localEstoque=${action.args.localEstoque.id}`;
      }

      if (action.excel) {
        yield call(getEstoqueAtualExcel, idPropriedade, where, totalizar);
      } else {
        yield call(getEstoqueAtualPdf, idPropriedade, where, totalizar);
      }

      yield put({ type: LIST_RELATORIO_ESTOQUE_ATUAL_PDF_SUCCESS });
    }
  } catch (error) {
    yield put({ type: LIST_RELATORIO_ESTOQUE_ATUAL_FAILURE });
  }
}

export default function* watchListAllRelatorioEstoqueAtual() {
  yield takeLatest(LIST_RELATORIO_ESTOQUE_ATUAL, sagaListAllRelatorioEstoqueAtual);
}
